const lang = {
    message: {

        injury_side: 'Injury side',
        fingertip_color:'Fingertip color',
        wrist_color:'Wirst color',
        arch_color:'Arch color',
        finger_color:'Fingers color',
        forearm_color:'Forearm color',
        cut:'Cut',
        left:'Left',
        right:'Right',
        two:'Two',
        form_a_request:'Form a request',
        send:'Send',
        phone:'Phone',
        email:'Email',
        deal_id:'Deal id',
        comment:'Comment',
        fio:'Full name',
        error:'Unexpected error occurred, try again later',
        deal_not_exist:'Deal id not exist',
        info_title:'Contact informstion',
        bad_email:'Bad email',
        bad_phone:'Bad phone',
        field_require:'This field require',
        deal_id_length:'The deal id must be at least 6 digits',
        deal_id_dig:'The deal id must consist only of numbers',
        success_message_1:'Congratulations, your Kibi prosthesis design configuration has been sent!',
        success_message_2:'In the near future, our specialist will contact you to discuss further steps.',
        
        
        
    }
}
export default lang
    